import { UserFacility } from "@services/facilityManagement";
import { formatFacilityDropdownLabel } from "@utils/facilityUtils";

function positiveId(value: unknown): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) return null;
  return n;
}

/** Facilities that can load customer agreements (verified or active, with customer and org ids). */
export function filterFacilitiesEligibleForAgreements(
  facilities: UserFacility[],
): UserFacility[] {
  return facilities.filter((f) => {
    if (f.is_verified !== true && f.is_active !== true) return false;
    const cid = positiveId(f["customer_id"]);
    const oid = positiveId(f["org_id"]);
    return cid !== null && oid !== null;
  });
}

export function getDefaultAgreementsFacility(
  facilities: UserFacility[],
): UserFacility | undefined {
  if (!facilities.length) return undefined;
  const affable = facilities.filter((f) => f.is_affable_connected === true);
  return affable[0] || facilities[0];
}

export function resolveInitialFacility(
  facilities: UserFacility[],
  preferredCustomerId?: number | null,
): UserFacility | undefined {
  if (preferredCustomerId != null) {
    const match = facilities.find((f) => getFacilityCustomerId(f) === preferredCustomerId);
    if (match) return match;
  }
  return getDefaultAgreementsFacility(facilities);
}

export function getFacilityCustomerId(facility: UserFacility): number | null {
  return positiveId(facility["customer_id"]);
}

export function facilityLabel(f: UserFacility): string {
  const formatted = formatFacilityDropdownLabel({
    facility_name: (f.facility_name || f.org_name || "").trim(),
    city: f.city || "",
    state: f.state || "",
    address_1: f.address_1 || "",
    ccn_number: f.ccn_number || "",
    country_code: f.country_code || "",
  });
  if (formatted && formatted.trim()) return formatted.trim();

  const name = f.facility_name || f.org_name;
  if (name && String(name).trim()) return String(name).trim();
  const id = f.facility_id ?? f.id;
  return id != null ? `Facility ${id}` : "Facility";
}
